/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PersonalAccessToken } from "./PersonalAccessToken";
export const CreatePersonalAccessTokenResponseData = core.serialization.object({
    token: core.serialization.string(),
    personalAccessToken: PersonalAccessToken,
});
